import { render } from "./PlatformLogDetails.vue?vue&type=template&id=86137a1e&scoped=true&ts=true"
import script from "./PlatformLogDetails.vue?vue&type=script&lang=ts"
export * from "./PlatformLogDetails.vue?vue&type=script&lang=ts"

import "./PlatformLogDetails.vue?vue&type=style&index=0&id=86137a1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86137a1e"]])

export default __exports__